import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { GetDetailProject, ProjectSelectChange } from "../../api/projectapi";
import ListSearchSection from "../../components/ListSearchSection/ListSearchSection";
import PostListSection from "../../components/PostListSection/PostListSection";
import { ProjectBasicDataType } from "../../interface/interface";
import { LoadingChange } from "../../reducers/config";

type Loc = {
  state: {
    prjt_id: string;
  };
  pathname: string;
};

type Path = "mtup" | "prjt";

const FinishProjectList = () => {
  const dispatch = useDispatch();
  const location = useLocation() as Loc;
  const category = location.pathname.split("/")[1] as Path;
  const [data, setdata] = useState([]);
  const [prjtData, setPrjtData] = useState<ProjectBasicDataType | undefined>(
    undefined
  );
  const GetData = useCallback(() => {
    if (location.state.prjt_id) {
      GetDetailProject(location.state.prjt_id).then(({ state, data }) => {
        if (state) {
          setPrjtData(data);
          const form = data.rcrt_apply_lst.map((item: any) => {
            return Object.assign({ prjt_sts_cd: data.prjt_sts_cd }, item);
          });
          setdata(form);
        }
      });
    }
  }, [location]);
  const __ChangeState = useCallback(
    (type: "reject" | "select" | "block" | "reselect", data: any) => {
      dispatch(LoadingChange(true));
      const { prjt_id, rcrt_id, apply_id } = data;
      return ProjectSelectChange(prjt_id, rcrt_id, apply_id, type).then(
        ({ state }) => {
          GetData();
          dispatch(LoadingChange(false));
          return state;
        }
      );
    },
    [data, GetData]
  );

  useEffect(() => {
    GetData();
    return () => {};
  }, [GetData]);

  return (
    <main>
      <div className="wrapper">
        <ListSearchSection
          title={`팀 ${category === "prjt" ? "프로젝트" : "밋업"} 신청리스트`}
          placeholder={"신청자 검색"}
          isExel={true}
          filter={[]}
          Search={undefined}
        />
        <PostListSection
          type="select-user"
          tags={last_layout}
          data={data}
          PostRemove={() => {}}
          ProjectPause={undefined}
          category={category}
          ChangeProjectSts={undefined}
          __ChangeState={__ChangeState}
          prjtData={prjtData}
        />
      </div>
    </main>
  );
};

export default FinishProjectList;

const last_layout = [
  {
    type: "select-user-id",
    title: "아이디",
  },
  {
    type: "select-user-email",
    title: "이메일",
  },
  {
    type: "select-user-time",
    title: "지원분야",
  },
];
